import { pageHead } from "@/lib/route-head";
import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const Insights = lazy(() => import("@/pages/Insights"));

export const Route = createFileRoute("/_public/insights")({
  head: () => pageHead({ path: "/insights", title: "Insights | Amorette", description: "Guides and insights from Amorette on curated dining, meeting people in person and real connection.", canonical: false }),
  component: Insights,
});
